import { format, isValid } from 'date-fns';

/**
 * Calendar date only (no time). Same pattern as `fDate` in
 * `components/ManagementPanel/utils/formatTime.ts`.
 */
export function formatDateForDisplay(value: unknown): string {
  if (value === null || value === undefined) {
    return '—';
  }
  const d = new Date(value as string | number | Date);
  if (!isValid(d)) {
    return String(value);
  }
  return format(d, 'dd MMMM yyyy');
}

/**
 * Date and time. Same pattern as `fDateTime` in
 * `components/ManagementPanel/utils/formatTime.ts`.
 */
export function formatDateTimeForDisplay(value: unknown): string {
  if (value === null || value === undefined) {
    return '—';
  }
  const d = new Date(value as string | number | Date);
  if (!isValid(d)) {
    return String(value);
  }
  return format(d, 'dd MMM yyyy HH:mm');
}
